module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_9_Queensland-Uni.e94c7007b50ef024ef9d8234f75c91ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_9_Queensland-Uni.png
// module id = 786
// module chunks = 0